import { Navigate, Outlet } from "react-router-dom";

import { useAuth } from "@/lib/auth";

/** Restricts nested routes to admin staff (editors are redirected). */
export function AdminOnlyRoute() {
  const { isAdmin, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-whart-bg text-sm text-neutral-500">
        Chargement…
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
